import { render, staticRenderFns } from "./Free.vue?vue&type=template&id=2a11a8d4&scoped=true"
import script from "./Free.vue?vue&type=script&lang=js"
export * from "./Free.vue?vue&type=script&lang=js"
import style0 from "./Free.vue?vue&type=style&index=0&id=2a11a8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11a8d4",
  null
  
)

export default component.exports